var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkrTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4909AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.316 5.68676C17.956 6.04676 17.926 6.60676 18.246 7.00676C19.696 8.82676 20.456 11.3168 19.776 13.9268C18.986 16.9768 16.596 19.2568 13.566 19.8668C8.46599 20.8768 3.99599 16.9368 3.99599 12.0068C3.99599 7.92677 7.04599 4.56677 10.996 4.07677V6.09677C7.86599 6.62677 5.56599 9.55677 6.06599 12.9268C6.45599 15.5368 8.62599 17.6368 11.246 17.9568C14.886 18.4068 17.996 15.5668 17.996 12.0068C17.996 10.7568 17.616 9.60677 16.966 8.64677C16.626 8.14677 15.896 8.11676 15.466 8.53676L15.456 8.54676C15.116 8.88676 15.086 9.41677 15.346 9.81677C15.946 10.7368 16.186 11.9168 15.836 13.1368C15.446 14.5068 14.296 15.5968 12.896 15.9068C10.296 16.4768 7.99599 14.5168 7.99599 12.0068C7.99599 10.1468 9.27599 8.59677 10.996 8.14677V10.2868C10.396 10.6368 9.99599 11.2668 9.99599 12.0068C9.99599 13.1068 10.896 14.0068 11.996 14.0068C13.096 14.0068 13.996 13.1068 13.996 12.0068C13.996 11.2668 13.596 10.6268 12.996 10.2868V2.71677C12.996 2.32677 12.676 2.00677 12.286 2.00677C6.92599 1.80677 2.30599 6.06676 2.01599 11.4068C1.65599 17.9568 7.42599 23.2268 14.026 21.8068C17.906 20.9768 20.906 18.0068 21.776 14.1368C22.486 10.9768 21.576 7.97677 19.806 5.76677C19.436 5.29677 18.736 5.26676 18.316 5.68676V5.68676Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkrTarget);
export default __webpack_public_path__ + "static/media/OKR_target.6b21199338e8ba346ea6186332489fbf.svg";
export { ForwardRef as ReactComponent };